export default `
.mce-content-body {
  color: #000;
  font-size: 14px;
  font-family: 'Roboto', 'PingFang SC', 'microsoft yahei ui', 'microsoft yahei', 'sans-serif';
  word-break: break-word;
}

.mce-content-body * {
  font-size: 14px !important;
  font-family: 'Roboto', 'PingFang SC', 'microsoft yahei ui', 'microsoft yahei', 'sans-serif' !important;
  word-break: break-word !important;
}

.mce-content-body p {
  margin: 0px;
  // margin-left: 5px;
}

.mce-content-body a[href] {
  color: #326ff0!important;
}

/* 无序列表样式 */
.mce-content-body ul {
  list-style: disc outside;
  // margin-left: 20px;
  // padding-left: 5px;
  margin-left: 15px;
  padding-left: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
}

/* 有序列表样式 - 实现Word文档效果：换行后与序号后文本对齐 */
.mce-content-body ol {
  list-style: decimal outside;
  margin-left: 15px;
  padding-left: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
}

/* 列表项样式 - 确保文本正确对齐 */
.mce-content-body ul li,
.mce-content-body ol li {
  padding-left: 5px;
  // line-height: 1.6;
}

/* 嵌套列表缩进 */
.mce-content-body ul ul,
.mce-content-body ol ol,
.mce-content-body ul ol,
.mce-content-body ol ul {
  margin-left: 25px;
}

/* .mce-content-body ul, ol, blockquote, dd, dl, figure, h1, h2, h3, h4, h5, h6, p, pre {
  padding: 0;
  margin: 0;
} */

.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
  line-height: 22px;
  font-weight: 400;
  font-style: normal !important;
  font-size: 14px;
  color: #bbbdcb !important;
}

html::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

html::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 9px;
}

html::-webkit-scrollbar-track {
  display: none;
}

.tox.tox-silver-sink.tox-tinymce-aux {
  .tox-toolbar__group {
    padding: 0 5px;
  }
}

`;
